import categoryImage from '../../public/icons/category.jpg';
import './CollegeMetaInfoList.css';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import actions from '../../redux/actions';
import { useLocation } from 'react-router-dom';
import BackArrow from '../../public/icons/mycoach-backarrow.svg';

const ProgramByUniversityList = (props) => {


    const { getProgramByUniversity, uniCourses } = props;
    const [programByUniversity, setprogramByUniversity] = useState(null);

    useEffect(() => {
        if (uniCourses?.label) {
            alert(uniCourses?.label)
             const fetchProgramByUniversityList = async () => {
                try {
                    const programByUniversityResp = await getProgramByUniversity(uniCourses.label);
                    if (programByUniversityResp?.data) {
                        setprogramByUniversity(programByUniversityResp.data);
                    } else {
                        setprogramByUniversity(null);
                    }
                } catch (error) {
                    console.error("Error fetching college info:", error);
                    setprogramByUniversity(null);
                }
            };
            fetchProgramByUniversityList();
        }
    }, [getProgramByUniversity, uniCourses]);


    return (
        <div style={{ paddingTop: '50px', paddingLeft: '50px' }}>
            <div style={{ backgroundColor: 'black', height: '23px', width: '23px', display:'flex',flexDirection:'row' }}>
                        <a href="/learner/university-list">
                            <img src={BackArrow} style={{ filter: 'brightness(0) invert(1)', padding: '3px' }} />
                        </a>
                        <h1>Programs in Different University</h1>
                        <h1>{localStorage.getItem("user_id")}</h1>
                    </div>

          



            {programByUniversity && programByUniversity.length > 0 ? (
                <div className="news-container">

                    {programByUniversity?.map((post, index) => (

                        <div className="news-item">
                            <img
                               
                                src={post?.logo || categoryImage}
                                alt={post?.name ?? ''}
                            />
                            <div className="news-content">
                                <h3 className="news-title">{post?.name ?? ''}</h3>
                                <h3 className="news-title">{uniCourses.label ?? ''}</h3>
                                <p className="news-description">{uniCourses.skills ?? ''}</p>
                                <p className="news-description">Price : {uniCourses.price ?? ''}</p>
                            </div>
                        </div>

                    ))}
                </div>
            ) : (
                <p style={{ textAlign: 'center', color: '#6B7280' }}>No course enrollments available.</p>
            )}
        </div>
    );
};

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => {
    const { getProgramByUniversity } = actions;
    return {

        getProgramByUniversity: (program_name) => dispatch(getProgramByUniversity(program_name)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ProgramByUniversityList);
